import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-mctcollect-rep",
  templateUrl: "./mctcollect-rep.component.html",
  styleUrls: ["./mctcollect-rep.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MctcollectRepComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
